import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import SearchBar from 'components/enhanced/form/fields/SearchBar';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import TenantPage from 'layouts/TenantPage';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { typeService } from 'shared/services';
import { TypesColumns } from '../types';

export const CostTypes = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.type';

  const [queryText, setQueryText] = useState();

  const columns: GridColDef[] = TypesColumns();

  const onSubmitSearch = async (values) => {
    setQueryText(values['q']);
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <div className="flex justify-end items-center">
          <SearchBar onSubmit={onSubmitSearch} />
          <AddEnhancedButton prefix={translationPrefix} to="new" requireTenantAdmin />
        </div>
      }>
      <EnhancedDataGrid columns={columns} service={typeService} fullTextQuery={queryText} />
    </TenantPage>
  );
};

export default CostTypes;
